<sh-empty-state
  id="log-empty-state"
  icon="log"
  label="{{
    (onlyErrorsMsg ? 'cts.gantry.noErrorsDetected' : 'cts.gantry.logsNotFound')
      | translate
  }}"
></sh-empty-state>
